import { InAppContentDefinition } from 'modules/graphql/types';

import { useEditableFieldsContext } from '../../../context/EditableFieldsContext';
import { SETTINGS_DISPLAY_CONTENT } from '../../constants';
import { FontFormField } from './shared/FontFormField';

export const RokuHeaderFont = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { ottPayload } = (liveTemplate?.mediumData || {}) as InAppContentDefinition;

  return (
    <FontFormField
      field="dialogHeaderFont"
      value={ottPayload?.dialogHeaderFont}
      condition={!!ottPayload?.dialogHeader}
      label={SETTINGS_DISPLAY_CONTENT.roku.fonts.headerLabel}
      data-test="form-field-roku-header-font"
    />
  );
};
